module.exports = __webpack_public_path__ + "static/media/chatBox.a046beb9.svg";